export default __webpack_public_path__ + "static/gtnexus-logo-713b1a3697198f94a956645948ef5abc.jpeg";